import React from "react";
import "./styles.css";

export default function Footer() {
  return (
    <div className="Footer">
      <a
        href="https://github.com/Kyicodes/react-weather"
        className="text-decoration-none"
      >
        Open-source{" "}
      </a>
      by Ta'kyiah Jones
    </div>
  );
}
